<template>
  <homepage brand="liveflight" @search="remove_all_filters" />
</template>

<script>
  import Homepage from '@/components/views/homepage.vue';
  import { remove_all_filters } from '@liveflight/utilities';

  export default {
    name: 'homepage-view',
    components: {
      homepage: Homepage,
    },
    mounted() {
      // Search should clean filter states
      this.remove_all_filters();
    },
    methods: {
      remove_all_filters,
    },
  };
</script>

<style lang="scss" scoped>
  .homepage-view ::v-deep .section--booking-engine {
    @include media-breakpoint-up(md) {
      // -100px against the hero's former section bottom margin, which collapsed with it
      margin-top: $grid-gutter-width * 2 - 100px;
    }
  }
</style>
